var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSamplingTube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: 345.18755539924535,
    y: 345.18755539924535,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n        .samplingTube-st0{stroke:currentColor;}\r\n        .samplingTube-st1{stroke:currentColor;}\r\n        .samplingTube-st2{stroke:currentColor;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "samplingTube-st0",
    fill: "#fff",
    d: "m35.25,18.82107l9.5,0l0,45.6c0,0.7 -0.2,1.3 -0.6,1.9c-1,1.3 -2.9,2.6 -4.1,2.6l0,0c-1.2,0 -3.1,-1.3 -4.1,-2.6c-0.4,-0.5 -0.6,-1.2 -0.6,-1.9l0,-45.6l-0.1,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "samplingTube-st1",
    d: "m40.05,69.32107c-1.5,0 -3.5,-1.4 -4.6,-2.8c-0.5,-0.6 -0.7,-1.4 -0.7,-2.2l0,-46l10.5,0l0,46.1c0,0.8 -0.3,1.5 -0.7,2.2c-1,1.3 -3.1,2.7 -4.5,2.7zm-4.2,-50l0,45.1c0,0.6 0.2,1.1 0.5,1.5c0.9,1.2 2.7,2.4 3.7,2.4s2.8,-1.2 3.8,-2.4c0.3,-0.4 0.5,-1 0.5,-1.5l0,-45.1l-8.5,0z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "samplingTube-st2",
    d: "m44.3,12.12107l-8.6,0c-1.2,0 -2.1,0.8 -2.1,1.8l0,5.1l12.8,0l0,-5.1c0,-1 -0.9,-1.8 -2.1,-1.8zm-7.6,5.7c0,0.3 -0.2,0.5 -0.5,0.5s-0.5,-0.2 -0.5,-0.5l0,-3.8c0,-0.3 0.2,-0.5 0.5,-0.5s0.5,0.2 0.5,0.5l0,3.8zm3.8,0c0,0.3 -0.2,0.5 -0.5,0.5s-0.5,-0.2 -0.5,-0.5l0,-3.8c0,-0.3 0.2,-0.5 0.5,-0.5s0.5,0.2 0.5,0.5l0,3.8zm3.8,0c0,0.3 -0.2,0.5 -0.5,0.5s-0.5,-0.2 -0.5,-0.5l0,-3.8c0,-0.3 0.2,-0.5 0.5,-0.5s0.5,0.2 0.5,0.5l0,3.8z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSamplingTube);
export default __webpack_public_path__ + "static/media/samplingTube.34ac49fa431df64a2bdff3e78667be95.svg";
export { ForwardRef as ReactComponent };